import rokeFavicon from './assets/roke-favicon.png';
import rokeLogo from './assets/roke-logo-darkblue.png';
import { setStyle } from './map/map.slice';
import MapStyle from './map/map-style';
import geollectTheme from './mui-themes/geollect';
import store from './store';
import TenantId from './tenant';

export type Tenant = keyof typeof TenantId;

export interface ColourScheme {
  sarTint: string;
  areaTint: string;
  drawActive: string;
  drawInactive: string;
  drawStatic: string;
}

interface ThemeItem {
  image: string;
  title: string;
  icon: string;
  mapboxStyle: string;
  colourScheme: string;
}

const geollectColours: ColourScheme = {
  sarTint: geollectTheme.palette.success.light,
  areaTint: geollectTheme.palette.success.light,
  drawActive: geollectTheme.palette.success.light,
  drawInactive: geollectTheme.palette.success.light,
  drawStatic: geollectTheme.palette.info.dark,
};

export const colourSchemes: Map<string, ColourScheme> = new Map([
  [TenantId.GEOLLECT, geollectColours],
]);

const themeVariables: Record<Tenant, ThemeItem> = {
  GEOLLECT: {
    image: rokeLogo,
    title: 'Geollect',
    icon: rokeFavicon,
    mapboxStyle: MapStyle.DEFAULT,
    colourScheme: TenantId.GEOLLECT,
  },
};

export const getFromTheme = (key: keyof ThemeItem, fallback?: string) =>
  themeVariables[TenantId.GEOLLECT][key] || fallback || '';

const updateFavicon = (icon: string) => {
  let favicon: HTMLLinkElement | null =
    document.querySelector("link[rel~='icon']");
  if (!favicon) {
    favicon = document.createElement('link');
    favicon.rel = 'icon';
    document.getElementsByTagName('head')[0].appendChild(favicon);
  }
  favicon.href = icon;
};

export const setTheme = (theme: Tenant) => {
  const { title, mapboxStyle, icon } = themeVariables.GEOLLECT;

  document.querySelector('html')?.setAttribute('data-theme', theme);
  document.title = title;
  updateFavicon(icon);
  store.dispatch(setStyle(mapboxStyle));
};

export const getDefaultMapboxStyle = () =>
  getFromTheme('mapboxStyle', themeVariables.GEOLLECT.mapboxStyle);
